const preloaderTextImage = require('../assets/images/preloader-text.png');

// Create new elements
var preloaderContainer = document.createElement('div'),
  preloaderBackground = document.createElement('div'),
  preloaderText = document.createElement('span');

// Content to element
preloaderText.style.backgroundImage = 'url(' + preloaderTextImage + ')';
preloaderBackground.append(preloaderText);
preloaderBackground.classList.add('bg-effect');
preloaderContainer.append(preloaderBackground);
preloaderContainer.setAttribute('id', 'preloader');

// Add elements to body
document.body.prepend(preloaderContainer);

// Prevent scrolling
preloaderContainer.addEventListener(
  'wheel',
  function (event) {
    event.stopPropagation();
  },
  { passive: false }
);

// Create a style element
var style = document.createElement('style');

// Define your CSS rules
var css = `
  #preloader {
    position: fixed;
    inset: 0;
    backdrop-filter: blur(20px);
    box-shadow: 0px 4px 50px 0px rgba(0, 0, 0, 0.2), 0px 1px 2px 0px rgba(0, 0, 0, 0.2);
    z-index: 100000;
  }

  #preloader.clear {
    animation: preloaderClear 800ms ease-in forwards;
  }

  @keyframes preloaderClear {
    50% {
      opacity: 1;
    }
    to {
      opacity: 0;
    }
  }

  #preloader .bg-effect {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 1150px;
    max-width: 100%;
    height: 300px;
    z-index: 0;
  }

  #preloader .bg-effect:before {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    width: 1150px;
    max-width: 120%;
    height: 300px;
    max-height: 120%;
    transform: translate(-50%, -50%);
    background-image: linear-gradient(90deg, #fbed96 0%, #abecd6 100%);
    background-size: 200%;
    filter: blur(100px);
    z-index: -1;
    animation: bgEffect 4s infinite alternate-reverse;
  }

  @keyframes bgEffect {
    from {
      background-position: 0% 100%;
    }
    to {
      background-position: 100% 0%;
    }
  }

  #preloader .bg-effect span {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 800px;
    max-width: 80%;
    height: 180px;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
  }

  #preloader.clear .bg-effect span {
    animation: preloaderClearText 400ms ease-in forwards;
  }

  @keyframes preloaderClearText {
    from {
      filter: blur(0px);
    }
    to {
      filter: blur(30px);
    }
  }
`;

// Append CSS rules to the style element
style.append(document.createTextNode(css));

// Append the style element to the head of the document
document.head.append(style);

// Prevent page from scrolling
document.body.style.overflowY = 'scroll';
document.body.style.position = 'fixed';
document.body.style.inset = '0';

// Remove preloader when window is fully loaded
window.addEventListener('load', function () {
  preloaderContainer.classList.add('clear');
  setTimeout(function () {
    preloaderContainer.remove();
    document.body.style.overflowY = 'auto';
    document.body.style.position = '';
    document.body.style.inset = '';
  }, 800); // Adjust the delay if needed to match your transition duration
});
